import React from 'react';
import AddToCartButton from '../../../Store/AddToCartButton';

class SeriesBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false
    };
  }

  mouseOver = () => {
    this.setState({
      hovered: true
    });
  };

  mouseLeave = () => {
    this.setState({
      hovered: false
    });
  };

  render() {
    const customColors = this.props.customColors || {
      title: {},
      description: {},
      background: {},
      backgroundHover: {},
      overlay: {}
    };
    let series = this.props.series;
    const cover = series.get('cover');
    if (cover) {
      cover.helper.on(
        'thumbnailLoaded',
        () => {
          this.forceUpdate();
        },
        this
      );
    }
    let target = this.props.openInNewTab ? '_blank' : '_self';
    let href = '/series/' + series.get('id');
    const showThumbnail =
      this.props.showThumbnail == null ? true : this.props.showThumbnail;
    const featured = cover ? cover.helper.featuredUrl(800) : '';
    let style = {backgroundImage: 'url(' + featured + ')'};
    let image = featured ? (
      <div className="media-image" style={style}>
        <div className="media-image-overlay" style={customColors.overlay} />
      </div>
    ) : null;

    let userOwned = FW.store.get('user') && FW.store.get('user').get('purchased_series').indexOf(series.get('id')) >= 0;

    return <div className="media-file">
      <a
        onMouseOver={this.mouseOver}
        onMouseLeave={this.mouseLeave}
        href={href}
        target={target}
        style={
          this.state.hovered
            ? customColors.backgroundHover
            : customColors.background
        }
      >
        <div style={{wordBreak: 'break-word'}}>
          {showThumbnail ? image : null}
          <h3 style={customColors.title}>{series.get('title')}</h3>
          <p style={customColors.description}>{series.get('description')}</p>
        </div>
      </a>
      {!userOwned && series.get('price') > 0 ? <AddToCartButton
        title={series.get('title')}
        price={series.get('price')}
        id={series.get('id')}
        type="media_series"
        image={featured}
      /> : null}
    </div>
    ;
  }
}

export default SeriesBlock;
